export default __webpack_public_path__ + "static/media/palik.674d3342.png";